import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

class SplideInit {

  constructor() {
    this.play()
  }

  play() {
    const splides = document.querySelectorAll('.career-teams__slider.splide')
    let odd = true
    splides.forEach(splide => {
      new Splide(splide, {
        type: 'loop',
        focus: 'center',
        gap: '1rem',
        drag: true,
        direction: odd ? 'rtl' : 'ltr',
        arrows: false,
        pagination: false,
        perPage: 1.5,
        autoScroll: {
          speed: .5,
        },
        mediaQuery: 'min',
        breakpoints: {
          600: {
            perPage: 3,
          },
          1024: {
            perPage: 4,
          },
          1536: {
            perPage: 5,
          },
          2048: {
            perPage: 8,
          },
        }
      }).mount({AutoScroll});
      odd = !odd
    })
  }

}

export default SplideInit